import { createAction } from '@reduxjs/toolkit';
import { categoriesSlice } from './reducer';

export const fetchCategories = createAction('categories/fetchCategories');

export const { receiveCategories } = categoriesSlice.actions;
